<template>
  <div class="company-register">
    <div class="company-register-wrapper">
      <div class="company-register-item">
        <label>{{ $t("system.CompanyName") }}</label>
        <span>
          <input v-model="model.RoleName" :placeholder="$t('placeholders.CompanyName')" type="text" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <div class="company-register-item">
        <label>{{ $t("mall.City") }}</label>
        <span>
          <input class="softKeyboardHide" @click="countryDialog" v-if="selectedText.length > 0" v-model="selectedText[0].label" :placeholder="$t('placeholders.SelectCity')" type="text" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <div class="company-register-item">
        <label>{{ $t("system.Industry") }}</label>
        <span>
          <input v-model="model.Remark" :placeholder="$t('placeholders.Industry')" type="text" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <div class="company-register-item">
        <label>{{ $t("mall.contacts") }}</label>
        <span>
          <input v-model="model.ContactInfo.ContactPeople" :placeholder="$t('placeholders.contacts')" type="text" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <registerInfo :currentView="currentView" :model="model" v-model="model.UserAccount"></registerInfo>
    </div>
    <picker @select="handleSelect(0, arguments)" ref="picker" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></picker>
  </div>
</template>
<style scoped>
  .company-register-wrapper {
    padding: 0 0.266rem;
  }

  .company-register-item {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    height: 1.197rem;
  }

  .company-register-item label {
    display: inline-block;
    width: 2.66rem;
    height: 0.798rem;
    line-height: 0.798rem;
  }

  .company-register-wrapper span {
    display: inline-block;
    height: 0.798rem;
    font-size: 0.399rem;
    line-height: 0.798rem;
  }

  .company-register-wrapper input {
    border: 0;
    height: 100%;
  }
</style>
<script>
  import baseService from "@/service/baseService";
  import picker from "../../modules/picker.vue";
  import registerInfo from "./register-info.vue";
  export default {
    data() {
      return {
        model: {
          RoleName: "",
          RootID: "",
          RoleType: "",
          UserAccount: {
            UserID: "",
            UserAct: "",
            UserPwd: "",
            ConfirmPwd: "",
            ValidCode: "",
            MobileCode: "",
          },
          ContactInfo: {
            CityID: "",
            ContactPeople: "",
          },
        },
        selectedIndex: [],
        cancelTxt: "share.cancelTxt",
        confirmTxt: "share.confirmTxt",
        selectedText: [],
        CountryLists: [],
      };
    },
    computed: {
      ZoneTypeTypes() {
        return this.$store.getters.categorys.types.ZoneType;
      },
    },
    created() {
      let __self = this;
      __self.getCitys();
    },
    props: ["currentView"],
    methods: {
      getCitys() {
        let __self = this;
        let data = {
          PageSize: 100000,
          CountryID: 151,
          ZoneType: __self.ZoneTypeTypes.City + "",
          Props: "ZoneCode,ZoneName,ZoneID",
        };
        baseService.getZoneList(data).then(function(json) {
          if (json.isSucc) {
            __self.CountryLists = json.result.entities;
            __self.CountryLists.forEach((o, index) => {
              o.label = o.ZoneName;
              if (o.ZoneName == __self.model.ContactInfo.CityID) {
                __self.selectedText.push(o);
                __self.$refs.picker.setSelectedIndex([index]);
              }
              __self.$refs.picker.setData([__self.CountryLists]);
            });
          }
        });
      },
      handleSelect(index, args) {
        let __self = this;
        __self.selectedText.splice(index, 1, args[2][0]);
        __self.model.ContactInfo.CityID = __self.selectedText[0].ZoneID;
      },
      countryDialog() {
        this.$refs.picker.show();
      },
    },
    components: {
      registerInfo,
      picker,
    },
  };
</script>
